<template>
    <ion-page>
        <base-header :title="formTitle" :buttons="[{ id: 1, label: 'Salva', disabled: !canSubmit, action: submit }]" />
        <ion-content v-if="!loading" :fullscreen="true">
            <ion-header collapse="condense">
                <ion-toolbar>
                    <ion-title style="text-align: left" size="large">
                        {{ formTitle }}
                    </ion-title>
                </ion-toolbar>
            </ion-header>
            <form ref="formEl" class="mei-form ion-padding-horizontal">
                <form-input
                    v-model="date"
                    name="date"
                    class="mei-input ion-margin-top-half"
                    :rules="[Validation.required]"
                    :type="FormInputType.date"
                    label="Data"
                    label-placement="stacked"></form-input>

                <div
                    class="w-full ion-margin-top-half"
                    style="padding: 0 8px; background-color: var(--ion-color-step-150); border-radius: 8px">
                    <ion-select
                        v-model="billing"
                        label-placement="floating"
                        label="Fatturazione"
                        placeholder="Fatturazione"
                        justify="space-between">
                        <ion-select-option :value="EBilling.annual">Annuale</ion-select-option>
                        <ion-select-option :value="EBilling.sixMonths">Semestrale</ion-select-option>
                        <ion-select-option :value="EBilling.sixMonthsPost">Semestrale posticipata</ion-select-option>
                    </ion-select>
                </div>
                <div
                    class="w-full ion-margin-top-half"
                    style="padding: 0 8px; background-color: var(--ion-color-step-150); border-radius: 8px">
                    <ion-select
                        v-model="billingMonths"
                        label-placement="floating"
                        label="Mesi di fatturazione"
                        placeholder="Mese di fatturazione"
                        justify="space-between"
                        :multiple="true">
                        <ion-select-option v-for="item in possibleBillingMonths" :value="String(item)" :key="item">
                            {{ item }}
                        </ion-select-option>
                    </ion-select>
                </div>

                <div class="w-full ion-margin-top-half">
                    <ion-text color="medium">Periodo del contratto</ion-text>
                    :
                    <div
                        class="mei-input"
                        style="background-color: var(--background); border-radius: 8px; overflow: hidden">
                        <form-input
                            v-model="startValidity"
                            name="start_validity"
                            class="mei-input"
                            :space="false"
                            :border="false"
                            :rules="[Validation.required, validateContractPeriod]"
                            :type="FormInputType.date"
                            label="Da"
                            label-placement="stacked"></form-input>
                        <hr style="background-color: var(--ion-color-step-300); margin: 0" />
                        <form-input
                            v-model="endValidity"
                            name="end_validity"
                            class="mei-input"
                            :space="false"
                            :border="false"
                            :rules="[Validation.required, validateContractPeriod]"
                            :type="FormInputType.date"
                            label="A"
                            label-placement="stacked"></form-input>
                    </div>
                </div>
                <div class="w-full ion-margin-top-half">
                    <ion-text color="medium">Servizi</ion-text>
                    :
                    <ion-list style="background-color: var(--ion-color-step-150); border-radius: 8px">
                        <ion-item style="--background: trasparent">
                            <ion-toggle class="w-full" v-model="monitoringRodent" justify="space-between">
                                Derattizzazione e monitoraggio roditori
                            </ion-toggle>
                        </ion-item>
                        <ion-item style="--background: trasparent">
                            <ion-toggle class="w-full" v-model="monitoringCrawling" justify="space-between">
                                Monitoraggio insetti striscianti - disinfestazione
                            </ion-toggle>
                        </ion-item>
                        <ion-item style="--background: trasparent">
                            <ion-toggle class="w-full" v-model="monitoringFlying" justify="space-between">
                                Monitoraggio insetti volanti
                            </ion-toggle>
                        </ion-item>
                        <ion-item style="--background: trasparent">
                            <ion-toggle class="w-full" v-model="monitoringFloursPests" justify="space-between">
                                Monitoraggio insetti delle derrate
                            </ion-toggle>
                        </ion-item>
                        <ion-item style="--background: trasparent" lines="none">
                            <ion-toggle class="w-full" v-model="haccp" justify="space-between">H.A.C.C.P.</ion-toggle>
                        </ion-item>
                    </ion-list>
                    <div v-if="!checkMonitoring">
                        <ion-note color="danger">
                            <small>
                                <em>Definisci almeno un servizio</em>
                            </small>
                        </ion-note>
                    </div>
                </div>

                <div
                    class="w-full ion-margin-top"
                    style="background-color: var(--ion-color-step-150); padding: 8px; border-radius: 8px">
                    <div class="w-full flex justify-between items-center">
                        <div>
                            <ion-label>Voci di spesa</ion-label>
                        </div>
                        <div>
                            <ion-button
                                @click="addExpenseItem"
                                fill="clear"
                                style="--padding-start: 0; --padding-end: 0; height: auto">
                                <ion-icon :icon="add"></ion-icon>
                            </ion-button>
                        </div>
                    </div>
                    <template v-if="expenseItems.length > 0">
                        <ion-list style="background: transparent" class="ion-margin-top-half">
                            <ion-item
                                v-for="(item, index) in expenseItems"
                                style="--padding-start: 0; --inner-padding-end: 0; --background: rgba(0, 0, 0, 0)">
                                <ion-label style="margin-top: 4px; margin-bottom: 4px; text-overflow: ellipsis">
                                    <span class="formset-item-counter" :class="{ zero: parseInt(item.quantity) === 0 }">
                                        {{ item.quantity }}
                                    </span>
                                    <span>{{ item.description }}</span>
                                </ion-label>
                                <div slot="end" style="display: flex; align-items: center; margin-left: 12px">
                                    <ion-note>
                                        <span v-if="item.price">{{ item.price }}&euro;&nbsp;&nbsp;&nbsp;</span>
                                        <small v-else class="text-sm" style="color: var(--ion-color-danger)">
                                            NESSUN PREZZO
                                        </small>
                                    </ion-note>
                                    <ion-buttons>
                                        <ion-button fill="clear" @click="editExpenseItem(item.id!)">
                                            <ion-icon color="primary" :icon="createOutline"></ion-icon>
                                        </ion-button>
                                        <ion-button fill="clear" @click="removeExpenseItem(item.id!)">
                                            <ion-icon color="danger" :icon="removeCircleOutline"></ion-icon>
                                        </ion-button>
                                    </ion-buttons>
                                </div>
                            </ion-item>
                        </ion-list>
                    </template>
                    <div class="" v-else>
                        <ion-note>
                            <small>
                                <em>Nessuna voce di spesa</em>
                            </small>
                        </ion-note>
                    </div>
                    <div v-if="!checkExpenseItems">
                        <ion-note color="danger">
                            <small>
                                <em>Alcune voci di spesa non sono state definite correttamente</em>
                            </small>
                        </ion-note>
                    </div>
                </div>
                <!-- TODO -->
                <ion-card v-show="canSubmit" class="w-full ion-margin-top">
                    <ion-card-header>
                        <ion-card-title>Scadenze previste dal contratto:</ion-card-title>
                    </ion-card-header>

                    <ion-card-content>
                        <span class="block">
                            Le seguenti scadenze sono state calcolate a partire dal
                            <strong style="color: var(--ion-text-color)">
                                {{ dateFormat(deadlineStartpoint ?? "") }}
                            </strong>
                            . Puoi cambiare la data di partenza
                            <span
                                @click="changeDeadlineStartpoint()"
                                style="text-decoration: underline; color: var(--ion-color-primary); cursor: pointer">
                                qui
                            </span>
                            .
                        </span>
                        <span class="block ion-margin-top-half">
                            Interventi annuali previsti:
                            <strong style="color: var(--ion-text-color)">
                                {{ deadlineInterventionsAmount }}
                            </strong>
                        </span>
                        <div>
                            Scadenze:
                            <ion-list
                                v-if="!previewLoading"
                                style="background: transparent"
                                class="ion-margin-top-half">
                                <ion-item
                                    v-for="(deadline, index) in deadlines"
                                    style="--padding-start: 0; --inner-padding-end: 0; --background: rgba(0, 0, 0, 0)">
                                    <ion-select
                                        justify="space-between"
                                        :label="`${index + 1}.`"
                                        @ionChange="onDeadlineChange($event, index)"
                                        :value="deadline"
                                        label-placement="fixed"
                                        style="--padding-end: 16px">
                                        <ion-select-option
                                            v-for="week in weeksFromStartpoint"
                                            :value="week.value"
                                            v-html="week.name"></ion-select-option>
                                        <div slot="end">
                                            <ion-icon color="primary" :icon="createOutline"></ion-icon>
                                        </div>
                                    </ion-select>
                                </ion-item>
                            </ion-list>
                            <div v-else style="text-align: center" class="ion-padding-top">
                                <ion-spinner></ion-spinner>
                            </div>
                        </div>
                    </ion-card-content>
                </ion-card>
                <ion-card v-show="!canSubmit" class="w-full ion-margin-top">
                    <ion-card-header>
                        <ion-card-title>Scadenze previste dal contratto:</ion-card-title>
                    </ion-card-header>

                    <ion-card-content style="text-align: center">
                        <ion-note color="medium">
                            <small>
                                <em>Completa il modulo per visualizzare le scadenze previste</em>
                            </small>
                        </ion-note>
                    </ion-card-content>
                </ion-card>
                <div class="w-full ion-margin-top ion-margin-bottom-double">
                    <h5 style="margin: 0">Dati del cliente riportati nel contratto:</h5>
                    <div class="w-full ion-margin-top-half">
                        <ion-text color="medium">Frequenza di intervento</ion-text>
                        :
                        <span v-if="interventionFrequency">
                            {{ interventionFrequency.description }}
                        </span>
                        <ion-note v-else>
                            <br />
                            &nbsp;&nbsp;&nbsp;&nbsp;
                            <small><em>Nessuna frequenza di intervento definita</em></small>
                        </ion-note>
                    </div>
                    <div v-if="interventionFrequency">
                        <div>
                            <small>
                                <ion-text color="medium">Interventi annuali</ion-text>
                                : {{ interventionFrequency.year_interventions_amount }}
                            </small>
                        </div>
                        <div>
                            <small>
                                <ion-text color="medium">Estremi intervalli di scadenza</ion-text>
                                : {{ interventionFrequency.recent_inspection_interval }} -
                                {{ interventionFrequency.regular_situation_interval }} -
                                {{ interventionFrequency.expiring_situation_interval }}
                            </small>
                        </div>
                    </div>
                </div>
            </form>
        </ion-content>
        <ion-content v-else>
            <ion-list>
                <ion-item class="costumer-list-item" v-for="_ in [1, 2, 3, 4, 5, 6, 7, 8, 9]">
                    <ion-label>
                        <h3>
                            <ion-skeleton-text :animated="true" style="width: 80%"></ion-skeleton-text>
                        </h3>
                        <p>
                            <ion-skeleton-text :animated="true" style="width: 60%"></ion-skeleton-text>
                        </p>
                        <p>
                            <ion-skeleton-text :animated="true" style="width: 30%"></ion-skeleton-text>
                        </p>
                    </ion-label>
                </ion-item>
            </ion-list>
        </ion-content>
    </ion-page>
</template>

<script setup lang="ts">
import {
    alertController,
    IonButton,
    IonButtons,
    IonCard,
    IonCardContent,
    IonCardHeader,
    IonCardTitle,
    IonContent,
    IonHeader,
    IonIcon,
    IonItem,
    IonLabel,
    IonList,
    IonNote,
    IonPage,
    IonSelect,
    IonSelectOption,
    IonSkeletonText,
    IonSpinner,
    IonText,
    IonTitle,
    IonToggle,
    IonToolbar,
    toastController,
} from "@ionic/vue";
import BaseHeader from "@/components/BaseHeader.vue";
import { computed, markRaw, onMounted, reactive, ref, watch } from "vue";
import { useContractsStore } from "@/stores/contracts";
import { useCostumersStore } from "@/stores/costumers";
import { EBilling, IContract, IExpenseItem } from "@/types/contract";
import { add, createOutline, removeCircleOutline } from "ionicons/icons";
import { ICostumer } from "@/types/costumer";
import FormInput from "@/components/FormInput.vue";
import { dateFormat, Validation } from "@/utility";
import { useInterventionFrequencyStore } from "@/stores/interventionFrequencies";
import { AxiosResponse } from "axios";
import { useRoute, useRouter } from "vue-router";
import { FormInputType } from "@/types/inputType";

const router = useRouter();
const route = useRoute();

const costumersStore = useCostumersStore();
const contractsStore = useContractsStore();
const interventionFrequenciesStore = useInterventionFrequencyStore();

const formEl = ref<HTMLFormElement | null>(null);
const loading = ref<boolean>(true);

const date = ref<string>(new Date().toISOString().substring(0, 10));
const startValidity = ref<string>("");
const endValidity = ref<string>("");
const billing = ref<string>("");
const billingMonths = ref<string[]>([]);
const monitoringRodent = ref<boolean>(false);
const monitoringCrawling = ref<boolean>(false);
const haccp = ref<boolean>(false);
const monitoringFlying = ref<boolean>(false);
const monitoringFloursPests = ref<boolean>(false);
const expenseItems = ref<IExpenseItem[]>([]);
const deadlineStartpoint = ref<string | undefined>(undefined);
const deadlineStepSize = ref<number | undefined>(undefined);
const deadlineInterventionsAmount = ref<number | undefined>(undefined);

const costumerId = parseInt(route.params.costumerId as string);
const contractId = parseInt(route.params.contractId as string);

const costumer = ref<ICostumer | undefined>(undefined);
const contract = ref<IContract | undefined>(undefined);

const interventionFrequency = computed(() =>
    costumer.value?.intervention_frequency
        ? interventionFrequenciesStore.getInterventionFrequencyById(costumer.value?.intervention_frequency)
        : null,
);

const previewLoading = ref<boolean>(false);
const deadlines = reactive<string[]>([]);

const formTitle = computed(() => {
    return Boolean(contract.value)
        ? `Contratto ${contract.value?.serial_number}-${contract.value?.serial_suffix}`
        : `Nuovo contratto per ${costumer.value?.business_name ?? ""}`;
});

const possibleBillingMonths = computed(
    // Generate array of string such as "Gennaio (2024)" spanning two years starting from 3 months ago
    () => {
        return new Array(24).fill(0).map((_, index) => {
            const date = new Date();
            date.setMonth(date.getMonth() - 3);
            date.setMonth(date.getMonth() + index);

            const formattedDate = dateFormat(date.toISOString().substring(0, 10), null, "long", null);
            const capitalizedDate = formattedDate.charAt(0).toUpperCase() + formattedDate.slice(1);
            // uppercase first letter of results
            return `${capitalizedDate} (${date.getFullYear()})`;
        });
    },
);

const weeksFromStartpoint = computed(() => {
    if (deadlineStartpoint.value) {
        return new Array(64).fill(0).map((_, index) => {
            const startpointDate = new Date(deadlineStartpoint.value!);
            const iterDate = new Date(deadlineStartpoint.value!);
            iterDate.setDate(iterDate.getDate() + index * 7);
            iterDate.setHours(5);
            let monday = new Date(iterDate);

            // get previous monday of iterDate
            while (monday.getDay() !== 1) {
                monday.setDate(monday.getDate() - 1);
            }

            let friday = new Date(monday);
            friday.setDate(friday.getDate() + 4);

            return {
                id: index,
                name: `${dateFormat(monday.toISOString().substring(0, 10), null, "short")} - ${dateFormat(
                    friday.toISOString().substring(0, 10),
                    null,
                    "short",
                )} ${friday.getFullYear() != startpointDate.getFullYear() ? "(" + friday.getFullYear() + ")" : ""}`,
                value: `${monday.toISOString().substring(0, 10)} | ${friday.toISOString().substring(0, 10)}`,
            };
        });
    }
});

const validateContractPeriod = (_: string) => {
    if (new Date(startValidity.value) >= new Date(endValidity.value)) {
        return "L'intervallo definito non è valido";
    }
    return null;
};

const updatePreview = () => {
    previewLoading.value = true;
    contractsStore
        .getDeadlinePreview(cleanedData.value as IContract, deadlineStartpoint.value?.trim() ?? undefined)
        .then((value) => {
            if (value && value.data) {
                deadlines.length = 0;
                deadlines.push(...(value.data as string[]));
            }
        })
        .finally(() => {
            previewLoading.value = false;
        });
};

const checkMonitoring = computed(() =>
    Boolean(
        monitoringRodent.value ||
            monitoringCrawling.value ||
            monitoringFlying.value ||
            monitoringFloursPests.value ||
            haccp.value,
    ),
);

const checkExpenseItems = computed(() =>
    expenseItems.value.reduce((acc, el) => {
        return acc && Boolean(el.quantity) && Boolean(el.description) && Boolean(el.price);
    }, true),
);

const canSubmit = computed(() => {
    const res =
        Boolean(date.value) &&
        Boolean(startValidity.value) &&
        Boolean(endValidity.value) &&
        Boolean(billingMonths.value.length > 0) &&
        validateContractPeriod("") == undefined &&
        checkExpenseItems.value &&
        Boolean(deadlineStartpoint.value) &&
        // Boolean(deadlines.length > 0) &&
        Boolean(
            monitoringRodent.value ||
                monitoringCrawling.value ||
                monitoringFlying.value ||
                monitoringFloursPests.value ||
                haccp.value,
        );
    if (res) {
        updatePreview();
    }
    return res;
});

const cleanedData = computed(() =>
    markRaw({
        date: date.value,
        costumer: costumer.value!.id,
        start_validity: startValidity.value,
        end_validity: endValidity.value,
        billing: billing.value,
        billing_months: billingMonths.value,
        items: expenseItems.value,
        city: costumer.value!.city,
        deadlines: deadlines,
        monitoring_rodent: monitoringRodent.value,
        monitoring_crawling: monitoringCrawling.value,
        haccp: haccp.value,
        monitoring_flying: monitoringFlying.value,
        monitoring_flours_pests: monitoringFloursPests.value,
    } as IContract),
);

watch(monitoringRodent, (value) => {}, { immediate: true });
watch(monitoringCrawling, (value) => {}, { immediate: true });
watch(
    monitoringFlying,
    (value) => {
        if (!contract.value) {
            if (value) {
                expenseItems.value.push({
                    id: new Date().valueOf() * -1,
                    quantity: interventionFrequency.value!.year_interventions_amount.toString(),
                    specialItemType: "flying",
                    description: "Prestazioni di controllo e sostituzione piastra collanti lampade U.V.",
                });
            } else {
                expenseItems.value.splice(
                    expenseItems.value.findIndex((el) => el.specialItemType === "flying"),
                    1,
                );
            }
        }
    },
    { immediate: true },
);
watch(
    monitoringFloursPests,
    (value) => {
        if (!contract.value) {
            if (value) {
                expenseItems.value.push({
                    id: new Date().valueOf() * -1,
                    quantity: interventionFrequency.value!.year_interventions_amount.toString(),
                    specialItemType: "flours_pests",
                    description: "Prestazioni di monitoraggio e controllo infestazioni da insetti delle derrate",
                });
            } else {
                expenseItems.value.splice(
                    expenseItems.value.findIndex((el) => el.specialItemType === "flours_pests"),
                    1,
                );
            }
        }
    },
    { immediate: true },
);
watch(
    haccp,
    (value) => {
        if (!contract.value) {
            if (value) {
                expenseItems.value.push({
                    id: new Date().valueOf() * -1,
                    quantity: "1",
                    specialItemType: "haccp",
                    description: "Servizio H.A.C.C.P. (redazione documentazione, sopralluogo, assistenza)",
                });
            } else {
                expenseItems.value.splice(
                    expenseItems.value.findIndex((el) => el.specialItemType === "haccp"),
                    1,
                );
            }
        }
    },
    { immediate: true },
);

onMounted(async () => {
    if (costumerId) {
        costumer.value = costumersStore.getCustomerById(costumerId);
    }
    if (contractId) {
        contract.value = contractsStore.getContractById(contractId);
        date.value = contract.value!.date;
        startValidity.value = contract.value!.start_validity;
        endValidity.value = contract.value!.end_validity;
        billing.value = contract.value!.billing;
        billingMonths.value.push(...contract.value!.billing_months);
        deadlines.push(...(contract.value?.deadlines ?? []));
        monitoringRodent.value = contract.value!.monitoring_rodent;
        monitoringCrawling.value = contract.value!.monitoring_crawling;
        haccp.value = contract.value!.haccp;
        monitoringFlying.value = contract.value!.monitoring_flying;
        expenseItems.value.push(...contract.value!.items);
        monitoringFloursPests.value = contract.value!.monitoring_flours_pests;
        deadlineStartpoint.value = contract.value!.deadlines![0].split("|")[0];
    } else {
        const response = await costumersStore.costumerDeadlineStartpoint(costumer.value!);
        deadlineStartpoint.value = response?.data["startpoint"];
        expenseItems.value.push({
            id: new Date().valueOf() * -1,
            quantity: interventionFrequency.value!.year_interventions_amount.toString(),
            description: "Prestazioni ordinarie + assistenza",
            price: 0,
        } as IExpenseItem);
    }

    deadlineStepSize.value = interventionFrequency.value!.regular_situation_interval;
    deadlineInterventionsAmount.value = interventionFrequency.value!.year_interventions_amount;

    loading.value = false;
});

const changeDeadlineStartpoint = async () => {
    const alert = await alertController.create({
        header: `Data della prima scadenza`,
        message: `Le altre scadenze verranno calcolate sulla base di questa data.`,
        inputs: [
            {
                placeholder: "gg/mm/aaaa",
                label: "Data della prima scadenza",
                type: "date",
                value: deadlineStartpoint.value,
            },
        ],
        buttons: [
            {
                text: "Annulla",
                role: "cancel",
                handler: () => {},
            },
            {
                text: "Aggiungi",
                role: "confirm",
                handler: (value: any) => {
                    if (0 in value) {
                        let date = Date.parse(value[0]);
                        if (!isNaN(date)) {
                            deadlineStartpoint.value = value[0];
                            updatePreview();
                        }
                    }
                },
            },
        ],
    });

    await alert.present();
};

const addExpenseItem = async () => {
    const alert = await alertController.create({
        header: `Aggiungi una voce di spesa`,
        inputs: [
            {
                placeholder: "Quantità",
                label: "Quantità",
                min: 0,
                type: "number",
                attributes: {
                    step: "1",
                },
            },
            {
                placeholder: "Descrizione",
                label: "Descrizione",
            },
            {
                placeholder: "Prezzo",
                label: "Prezzo",
                min: 0,
                type: "number",
            },
        ],
        buttons: [
            {
                text: "Annulla",
                role: "cancel",
                handler: () => {},
            },
            {
                text: "Aggiungi",
                role: "confirm",
                handler: (value: any) => {
                    const quantity = value[0];
                    const description = value[1];
                    const price = value[2];
                    expenseItems.value.push({
                        id: new Date().valueOf() * -1,
                        quantity: quantity,
                        description: description,
                        price: price,
                    });
                },
            },
        ],
    });

    await alert.present();
};

const editExpenseItem = async (id: number) => {
    const expenseItem = expenseItems.value.at(expenseItems.value.findIndex((el) => el.id === id));
    const alert = await alertController.create({
        header: `Modifica voce di spesa`,
        subHeader: "Quantità, Descrizione e Prezzo",
        inputs: [
            {
                placeholder: "Quantità",
                label: "Quantità",
                min: 0,
                value: expenseItem!.quantity,
                type: "number",
                attributes: {
                    step: "1",
                    min: 0,
                },
            },
            {
                placeholder: "Descrizione",
                label: "Descrizione",
                type: "text",
                value: expenseItem!.description,
            },
            {
                placeholder: "Prezzo",
                label: "Prezzo",
                min: 0,
                type: "number",
                value: expenseItem!.price,
            },
        ],
        buttons: [
            {
                text: "Annulla",
                role: "cancel",
                handler: () => {},
            },
            {
                text: "Salva",
                role: "confirm",
                handler: (value: any) => {
                    expenseItem!.quantity = value[0];
                    expenseItem!.description = value[1];
                    expenseItem!.price = value[2];
                },
            },
        ],
    });

    await alert.present();
};

const removeExpenseItem = async (id: number) => {
    expenseItems.value.splice(
        expenseItems.value.findIndex((el) => el.id === id),
        1,
    );
};

const submit = async () => {
    let response: AxiosResponse<any, any> | undefined;
    if (contract.value) {
        response = await contractsStore.updateContract({ id: contract.value.id, ...cleanedData.value } as IContract);
    } else {
        response = await contractsStore.createContract(cleanedData.value as IContract);
    }
    if (response && (response.status === 201 || response.status === 200)) {
        const toast = await toastController.create({
            message: "Contratto salvato con successo",
            color: "success",
            duration: 2000,
        });
        await toast.present();
    }
    router.back();
};

const onDeadlineChange = (event: any, index: number) => {
    deadlines[index] = event.target.value;
};
</script>

<style scoped lang="scss">
ion-title.title-large {
    font-size: 20px;
}

.mei-form {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
}

.formset-item-counter {
    display: inline-block;
    margin: 0 12px;
    padding: 3px;
    background-color: var(--ion-color-primary);
    border-radius: 25px;
    min-width: 25px;
    text-align: center;
    font-weight: bold;
}

.formset-item-counter.zero {
    background-color: var(--ion-color-danger);
}

.deadline-preview-list > li::marker {
    font-weight: bold;
    color: var(--ion-text-color);
}

ion-select::part(icon) {
    display: none !important;
}
</style>
